<template>
  <div style="padding: 15px 15px">
    <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
      <el-form-item :label="$t('Token')">
        <el-input v-model="token" :placeholder="$t('Token')" style="width: 400px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetchData">{{
          $t("查询")
          }}</el-button>
      </el-form-item>
    </el-form>

    <!-- <div style="margin-bottom: 10px">
      <el-avatar
        style="vertical-align: middle"
        :size="40"
        :src="caInfoMap.logo"
      ></el-avatar>

      <span style="font-size: 13px">
        {{ $t("Currency") }}: {{ caInfoMap.symbol }}&emsp;&emsp;
        {{ $t("Market cap") }}:{{ caInfoMap.marketCap }}&emsp;&emsp; 
        {{ $t("Duration") }}:{{ caInfoMap.createMinutes }}&emsp;&emsp; 
      </span>
    </div> -->

    <div class="tables-container table-bottom">
       <el-table
        :data="allAddress"
        v-loading="loading"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '5px' }"
        border
        class="table-left"
      >
        <el-table-column
          prop="address"
          :label="$t('【所有购买地址】')"
        >
        </el-table-column>

        <el-table-column
          prop="name"
          :label="$t('昵称')"
        >
        </el-table-column>
        
        <el-table-column
          prop="amount"
          :label="$t('占比')"
        >
        </el-table-column>
        
      </el-table>
      <el-table :data="joinAddress" v-loading="loading" :row-style="{ height: '0' }" :cell-style="{ padding: '5px' }"
        border class="table-left">
        <el-table-column prop="address" :label="$t('【参与地址】')">
          <template slot-scope="scope">
            <a :href="`https://gmgn.ai/sol/address/${scope.row.address}`" target="_blank" :class="'link-color'">
              {{ scope.row.address.substring(0, 4) + '....' + scope.row.address.substring(scope.row.address.length - 3,
                scope.row.address.length) }}
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('昵称')">
        </el-table-column>
        <el-table-column prop="amount" :label="$t('占比')">
        </el-table-column>

        <el-table-column prop="buyTime" :label="$t('买时间')">
          <template slot-scope="scope">
            {{ parsedTime(scope.row.buyTime)}}
          </template>
        </el-table-column>

        <el-table-column prop="sellCount" :label="$t('买/卖')">
          <template slot-scope="scope">
            {{ scope.row.buyCount + "/" + scope.row.sellCount }}
          </template>
        </el-table-column>

        <el-table-column prop="sellTime" :label="$t('卖时间')">
          <template slot-scope="scope">
            {{ parsedTime(scope.row.sellTime)}}
          </template>
        </el-table-column>

      </el-table>

      <el-table :data="otherAddress" v-loading="loading" :row-style="{ height: '0' }" :cell-style="{ padding: '5px' }" border
        class="table-left">
        <el-table-column prop="address" :label="$t('【外部地址】')">
          <template slot-scope="scope">
            <a :href="`https://gmgn.ai/sol/address/${scope.row.address}`" target="_blank" :class="'link-color'">
              {{ scope.row.address.substring(0, 4) + '....' + scope.row.address.substring(scope.row.address.length - 3,
                scope.row.address.length) }}
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('占比')">
        </el-table-column>
      </el-table>
    </div>

    <div>
      <!-- <el-table
        :data="topMapList"
        v-loading="loading"
        style="width: 100%"
        max-height="1000"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '0' }"
        :row-class-name="getRowClassName"
        border
      >
        <el-table-column prop="address" :label="$t('Top analysis')" width="430">
          <template slot-scope="scope">
            <a
              :href="`https://gmgn.ai/sol/address/${scope.row.address}`"
              target="_blank"
              :class="'link-color'"
              >{{ scope.row.address }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="solBalance"
          :label="$t('No displaying if below 1')"
        >
        </el-table-column>
        <el-table-column prop="amountResult" :label="$t('Proportion%')">
        </el-table-column>
        <el-table-column prop="from" :label="$t('Sources of recent funding')">
        </el-table-column>
        <el-table-column prop="newWallet" :label="$t('Wallet created within 24-hours')">
        </el-table-column>
        <el-table-column prop="formattedTime" :label="$t('Trade time')">
        </el-table-column>
        <el-table-column prop="holdMinutes" :label="$t('Hold minutes')">
        </el-table-column>
        <el-table-column prop="profitChangeResult" :label="$t('Profit(%)(no displaying if negative)')">
        </el-table-column>
        <el-table-column prop="boduanStr" :label="$t('Trading style')">
        </el-table-column>
        <el-table-column prop="remarks" :label="$t('Wallet remarks')"> 
        </el-table-column>
      </el-table> -->
    </div>
  </div>
</template>

<script>
import Plate from "./Plate";
export default {
  name: "mouse",
  components: { Plate },
  data() {
    return {
      number: "*",
      token: "",
      pumpca: "",
      caInfoMap: "",
      mouse: [],
      wallet: [],
      topMapList: [],
      wallerInfoList: [],
      goldenDogs: [],
      insideDishs: [],
      joinAddress: [],
      buyAddress: [],
      otherAddress: [],
      allAddress: [],
      allAddress: [],
      loading: false,
      pumpurl: "",
      gmgnai: "",
      bubble: "",
      lang: this.$i18n.locale,
      themeType: "dark",
      dialogVisible: false,
      width: window.innerWidth / 3,
      data: [],
      remarkDialogShow: false,
      remarkDialogData: [],
      retrievedMap: new Map()
    };
  },
  mounted() {
    this.httpGetRemarks();
    let themeClass = localStorage.getItem("theme");
    this.themeType = themeClass.split("-")[0];
    document.getElementById("app").setAttribute("class", themeClass);
  },
  methods: {
    fetchData() {
      if (
        this.token === null ||
        this.token === undefined ||
        this.token === ""
      ) {
        this.$message({
          message: this.$t("Please enter Token"),
          type: "error",
          duration: 1000,
        });
        return;
      }

      this.loading = true;
      this.$axios
        .get("/api/selectCto/" + this.token.trim())
        .then((successResponse) => {
          this.joinAddress = successResponse.data.joinAddress;
          this.buyAddress = successResponse.data.buyAddress;
          this.otherAddress = successResponse.data.otherAddress;
          this.allAddress = successResponse.data.allAddress;
          this.loading = false;
        })
        .catch((failResponse) => {
          this.$message({
            message: failResponse.response.data,
            type: "error",
            duration: 2000,
          });
          this.loading = false;
          // 处理失败响应
        });
    },
    loadData() {
      
    },
    getRowClassName({ row, index }) {
      if (row.isMouse === 1) {
        return "row-color-2";
      }
    },
    copyValue(symbol) {
      this.$message({
        message: this.$t("Copy successful"),
        type: "success",
        duration: 500,
      });
      navigator.clipboard
        .writeText(symbol)
        .then(function () { })
        .catch(function (err) { });
    },
    parsedTime(e) {
      if(e != null && e != 'null' && e != ''){
        return new Date(e * 1000).toLocaleString();
      }else{
        return ''
      }
    },
  },
};
</script>

<style scoped>
.tables-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.link-color {
  color: #409eff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 30px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon-sunny {
  font-size: 25px;
  margin-left: 20px;
}

.el-icon-moon {
  font-size: 25px;
  margin-left: 20px;
}

.el-icon-s-promotion {
  margin-left: 25px;
  font-size: 30px;
}

.box-three {
  margin: 30px 0;
}

.table-left {
  margin-right: 15px;
}

.table-bottom {
  margin-bottom: 30px;
}

.remarkSave {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
}

.box {
  display: flex;
}

.box-column-center {
  justify-content: center;
}

.box-center {
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Cto.vue